import React from "react";
import { Heading } from "./heading";
import { Text } from "./text";
import Breadcrumbs, { Breadcrumb } from "src/components/base/breadcrumb";

/**
 * The properties for {@link TabLayout}
 */
export type TabLayoutProps = {
    /** The heading to display */
    heading: string;
    /** The description of the heading */
    headingDescription?: React.ReactNode;
    /** Children of the heading */
    headingChildren?: React.ReactNode;
    /** Optional breadcrumb trail rendered above the heading. */
    breadcrumbs?: Array<Breadcrumb>;
    /**
     * Optional content rendered between the heading row and the tab bar —
     * intended for status pills, metadata strips, etc.
     */
    headingMeta?: React.ReactNode;
    /** The tabs to render */
    tabs: React.ReactNode;
    /** The content of the site */
    children: React.ReactNode;
};

/**
 * A layout for tabbed sub-pages.
 */
export default function TabLayout(props: TabLayoutProps) {
    return (
        <div className={"flex flex-col gap-3"}>
            {props.breadcrumbs && props.breadcrumbs.length > 0 && <Breadcrumbs items={props.breadcrumbs} />}
            <div className={"flex w-full flex-wrap items-end justify-between gap-4 pb-2"}>
                <div className={"flex flex-col gap-3"}>
                    <Heading>{props.heading}</Heading>
                    {props.headingDescription && <Text>{props.headingDescription}</Text>}
                </div>
                {props.headingChildren !== undefined ? (
                    <div className={"flex flex-wrap items-center gap-2"}>{props.headingChildren}</div>
                ) : undefined}
            </div>
            {props.headingMeta && <div className={"-mt-2 pb-4"}>{props.headingMeta}</div>}
            {props.tabs}
            <div className={"mt-6"}>{props.children}</div>
        </div>
    );
}
